import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleSetSelectedFilterIds,
  handleToggleCollapsed,
  handleSetSelectedContentBasedValues,
  handleChangeSortBy,
  handleSetSelectedFilterValue,
} from 'store/helpers/filterHelpers';
import { handleApplySettingsFilters } from './resourceHelpers';
import { virastyFiltersInitialState } from './initialState/virastyInitialState';

export { virastyFiltersInitialState as filtersInitialState };

export const virastySearchResourceInitialState = {
  filters: virastyFiltersInitialState,
  sortBy: {
    selected: 'follower_count',
    order: 'desc',
  },
  selectedFilter: 'contentBasedFilter',
};
export const virastySearchResourceSlice = createSlice({
  name: 'virastySearchResourceSlice',
  initialState: virastySearchResourceInitialState,
  reducers: {
    setSelectedFilterIds: (state, action) => {
      handleSetSelectedFilterIds(state, action);
    },
    setSelectedContentBasedValues: (state, action) => {
      handleSetSelectedContentBasedValues(state, action);
    },
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(state, action, virastyFiltersInitialState);
    },
    changeSortBy: (state, action) => {
      handleChangeSortBy(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = virastyFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, virastyFiltersInitialState);
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const {
  setSelectedFilterIds,
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  setSelectedContentBasedValues,
  setSelectedFilterValue,
  changeSortBy,
  applyWebsiteSettingsFilters,
  setSelectedFilter,
} = virastySearchResourceSlice.actions;
